const apiKeyResponse = { apiKey: '123456789' }

export default apiKeyResponse
